<h2 mat-dialog-title>Delete "{{ device.name }}"</h2>

<mat-dialog-content>
  <p>
    <span class="confirm-text-full">This action cannot be undone. To confirm, type <strong>{{ requiredWord }}</strong> below.</span>
    <span class="confirm-text-short">Type <strong>{{ requiredWord }}</strong> to confirm delete.</span>
  </p>
  <mat-form-field floatLabel="auto">
    <mat-label>Type to confirm</mat-label>
    <input matInput [(ngModel)]="confirmationInput" autocomplete="off" />
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="warn" [disabled]="!isConfirmed" (click)="onConfirm()">
    Delete
  </button>
</mat-dialog-actions>
